/** Align with backend constants/permissions.js and mst_submodules.submodule_slug */
export const INWARD_OUTWARD_REGISTER_SUBMODULE_SLUG = "inward-outward-register";
export const INWARDS_REGISTER_SUBMODULE_SLUG = "inwards-register";
export const OUTWARDS_REGISTER_SUBMODULE_SLUG = "outwards-register";
